import React, { useState } from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalBody,
    Button,
    FormControl,
    FormLabel,
    Input,
    Stack,
    Text,
    CloseButton,
    Box,
    HStack,
    InputGroup,
    InputRightElement,
    Link,
    Flex,
    VStack, useToast
} from "@chakra-ui/react";
import GoogleButton from "../../buttons/GoogleButton";
import {handleSignUp} from "../../../utils/auth-helpers";
import {deleteDocument} from "../../../utils/home-page-helpers";
import {fetchDocuments} from "../../../utils/redux-helpers";
import {setDocuments} from "../../../redux/reducers";
import {useDispatch} from "react-redux";
import {useTranslation} from "react-i18next";
import {useServerIP} from "../../../redux/ServerIPContext";

const DeleteScreen1 = ({ isOpenDelete1, onCloseDelete1, userID, fileID }) => {
    const [isLoading, setIsLoading] = useState(false);
    const toast = useToast();
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const { serverIPs, setServerIPs, isDev } = useServerIP();

    const deleteAction = async () => {
        setIsLoading(true)
        await deleteDocument(userID, fileID, serverIPs.SERVER_IP).then((response) => {
            setIsLoading(false)
            if (response === null) {
                toast({
                    title: t('Oops, something went wrong. Please try again.'),
                    status: "error",
                    duration: 5000,
                    isClosable: true,
                })
            } else if (response.status === 400) {
                toast({
                    title: t('400 error. Please try again.'),
                    status: "error",
                    duration: 5000,
                    isClosable: true,
                })
            } else if (response.status === 200) {
                fetchDocuments(userID, serverIPs.SERVER_IP).then(r => {
                    dispatch(setDocuments(r.documents));
                })
                toast({
                    title: t('Successfully deleted.'),
                    status: "success",
                    duration: 5000,
                    isClosable: true,
                })
                onCloseDelete1();
            }
        });
    };

    return (
        <>
            <Modal isOpen={isOpenDelete1} onClose={onCloseDelete1} isCentered size="xl">
                <ModalOverlay />
                <ModalContent borderRadius="1rem" p="0.75rem" h="18rem" w="26rem" overflowY="auto" position="relative">
                    <Box
                        position="absolute"
                        top="10px"
                        right="10px"
                        zIndex={999}
                    >
                        <CloseButton
                            size="md"
                            onClick={onCloseDelete1}
                            bg="transparent"
                            borderRadius="50%"
                            _hover={{
                                bg: "gray.200",
                                borderRadius: "50%",
                            }}
                        />
                    </Box>
                    <Flex alignItems="center" justifyContent="space-between" p={4} >
                        <VStack align="center" width={'100%'} spacing={6}>
                            <Text fontSize="xl" fontWeight="bold">{t('Are You Sure?')}</Text>
                            <Text fontSize="sm" fontWeight="light" textAlign={"center"}>{t('This document and its chat/notes history ' +
                                'will be deleted. You can always reupload the same document later and start from scratch.')}</Text>
                            {/*<GoogleButton />*/}
                            {/*<HStack width={'100%'}>*/}
                            {/*    <Box w={'full'} h={'1px'} bg={'gray.300'} />*/}
                            {/*    <Text fontSize={'sm'} color={'gray.500'}>or</Text>*/}
                            {/*    <Box w={'full'} h={'1px'} bg={'gray.300'} />*/}
                            {/*</HStack>*/}
                        </VStack>
                    </Flex>
                    <ModalBody>
                        <Stack spacing={4}>
                            <Stack spacing={10} pt={4}>
                                <Button
                                    loadingText="Submitting"
                                    size="lg"
                                    isLoading={isLoading}
                                    bg={'red.400'}
                                    color={'white'}
                                    onClick={deleteAction}
                                    _hover={{
                                        bg: 'red.500',
                                    }}>
                                    {t('Delete Document')}
                                </Button>
                            </Stack>
                            {/*<Stack pt={6}>*/}
                            {/*    <Text align={'center'}>*/}
                            {/*        Already a user? <Link color={'blue.400'} onClick={()=>{*/}
                            {/*        onCloseSignUpScreen1();*/}
                            {/*        onOpenSignInScreen1();*/}
                            {/*    }}>Sign In</Link>*/}
                            {/*    </Text>*/}
                            {/*</Stack>*/}
                        </Stack>
                    </ModalBody>
                </ModalContent>
            </Modal>
            {/*<SignUpScreen2*/}
            {/*    isOpen={isOpenSignUpScreen2}*/}
            {/*    onClose={() => setIsOpenSignUpScreen2(false)}*/}
            {/*    email={email}*/}
            {/*/>*/}
        </>
    );
};

export default DeleteScreen1;








